/* Reprice the cart for the current customer. See snippets/cart-pricing-sync.liquid. */
(() => {
  const ATTRIBUTE = '_pricing_key';
  let queue = Promise.resolve();

  async function postAttribute(cartItems, value) {
    const payload = { attributes: { [ATTRIBUTE]: value } };
    if (cartItems) return cartItems.postCart(`${routes.cart_update_url}.js`, payload);

    const response = await fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    return response.json();
  }

  async function sync() {
    const marker = document.getElementById('CartPricingSync');
    if (!marker) return;
    const { expected, current, itemCount } = marker.dataset;
    if (expected === current || Number(itemCount) === 0) return;

    if (document.querySelector('cart-items')) await customElements.whenDefined('cart-items');
    const cartItems = document.querySelector('cart-items');
    const renderedItem = cartItems?.querySelector('.ba-cartItems__item');

    try {
      const cart = await postAttribute(cartItems, expected);
      if (typeof cart?.item_count !== 'number') throw new Error('Cart was not repriced');
      if (cartItems && renderedItem !== cartItems.querySelector('.ba-cartItems__item')) {
        scheduleSync();
        return;
      }
      // Only now is the cart priced for this customer; a failure retries next page.
      marker.dataset.current = expected;
      if (cartItems) {
        cartItems.renderSections(cart.sections);
        cartItems.syncCartUI(cart);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      }
    } catch (error) {
      console.error('Cart pricing sync failed', error);
    }
  }

  // Serialize so a login during an in-flight sync is applied after it, never before.
  function scheduleSync() {
    queue = queue.then(sync);
  }

  scheduleSync();
  // The login modal swaps the marker for the new customer's without a page load.
  window.addEventListener('ne:customer-state', scheduleSync);
})();
